import { normalizeStatusKey } from "../../../../../../../../../shared/utils/normalize-status-label";

export const filterPendingTickets = <T extends { status: string }>(
	tickets: T[] | undefined,
): T[] =>
	(tickets ?? []).filter(
		(ticket) => normalizeStatusKey(ticket.status) === "pending",
	);
